import rangeSlider from 'range-slider-input'
import { currencyStore } from '../../localization/currency'
import i18next, { t } from 'i18next'
import { calculateFinalPrice } from '../cloud-vps/calculateFinalPrice'

const allTariffs = window.tariffsData?.tariffs || []
const filterWrapper = document.querySelector('[data-filter-wrapper]')
const tableContainer = document.querySelector('.comparison_table')
const listContainer = document.querySelector('.comparison__list')
const clearFilterEl = document.querySelector('[data-filter-clear]')
const filterActionBar = document.querySelector('[data-filtered-actions]')
const foundItems = document.querySelector('[data-found-items]')

let currentLocationFilter = null
let currencyData = currencyStore.getSelectedCurr()

let currentPeriod = 30
let currentIpType = 'ipv4'

let cachedcategoryCheckboxes = null
let cachedTariffElements = null
let currentPriceRange = null
let rangeSliderInstance = null
let currentSliderValues = null

const roundDown = value => Math.floor(value * 100) / 100
const roundUp = value => Math.ceil(value * 100) / 100
const formatPrice = value => parseFloat(value.toFixed(2))

function updateCurrencySymbols() {
  const currencyElements = document.querySelectorAll('[data-price-field-currency]')
  currencyElements.forEach(element => {
    element.innerHTML = currencyData.symbol
  })
}

function getTariffPrice(tariff) {
  const exchangeRate = currencyData.currency
  let basePrice = 0

  if (tariff.discount_price != null) {
    if (currentIpType === 'ipv6') {
      basePrice = tariff.month_discount_price_ipv6 || tariff.month_discount_price
    } else {
      basePrice = tariff.month_discount_price_ipv4 || tariff.month_discount_price
    }
  } else {
    if (currentIpType === 'ipv6') {
      basePrice = tariff.day_no_discount_price_ipv6 || tariff.day_no_discount_price
    } else {
      basePrice = tariff.day_no_discount_price_ipv4 || tariff.day_no_discount_price
    }
  }

  return calculateFinalPrice(basePrice, currentPeriod, exchangeRate)
}

function destroySlider() {
  if (rangeSliderInstance) {
    const rangeElement = filterWrapper.querySelector('[data-range="price"]')
    if (rangeElement) {
      rangeElement.innerHTML = ''
      rangeElement.classList.remove('range-slider')
    }
    rangeSliderInstance = null
  }
}

function initializeSlider() {
  if (!filterWrapper) return

  const rangeElement = filterWrapper.querySelector('[data-range="price"]')
  let minPriceField = filterWrapper.querySelector('[data-price-min]')
  let maxPriceField = filterWrapper.querySelector('[data-price-max]')

  const { min, max } = getGlobalPriceRange()

  if (!rangeElement || !minPriceField || !maxPriceField || isNaN(min) || isNaN(max)) {
    console.warn('No valid prices found in tariffs')
    return
  }

  currentSliderValues = [min, max]

  rangeSliderInstance = rangeSlider(rangeElement, {
    min: min,
    max: max,
    rangeSlideDisabled: true,
    value: [min, max],
    step: 0.01,
    onInput: (value, isRangeTarget) => {
      if (isRangeTarget) {
        let formattedMin = formatPrice(value[0])
        let formattedMax = roundUp(value[1])

        const minAllowedMax = formatPrice(formattedMin + 0.01)
        if (formattedMax < minAllowedMax) {
          formattedMax = minAllowedMax
        }

        currentSliderValues = [formattedMin, formattedMax]

        const currentMinField = filterWrapper.querySelector('[data-price-min]')
        const currentMaxField = filterWrapper.querySelector('[data-price-max]')

        if (currentMinField && currentMaxField) {
          currentMinField.value = formattedMin.toFixed(2)
          currentMaxField.value = roundUp(formattedMax).toFixed(2)
        }

        if (formattedMax !== formatPrice(value[1])) {
          rangeSliderInstance.value([formattedMin, formattedMax])
        }

        handlePriceRangeChange(formattedMin, formattedMax)
      }
    },
  })

  minPriceField.value = min.toFixed(2)
  maxPriceField.value = max.toFixed(2)

  const newMinField = minPriceField.cloneNode(true)
  const newMaxField = maxPriceField.cloneNode(true)
  minPriceField.parentNode.replaceChild(newMinField, minPriceField)
  maxPriceField.parentNode.replaceChild(newMaxField, maxPriceField)

  minPriceField = newMinField
  maxPriceField = newMaxField

  minPriceField.addEventListener('input', function (e) {
    const inputValue = e.target.value.trim()

    if (inputValue === '') {
      return
    }

    const targetValue = parseFloat(inputValue)

    if (!isNaN(targetValue) && targetValue >= 0) {
      const formattedValue = formatPrice(targetValue)

      if (formattedValue > currentSliderValues[1]) {
        const newMaxValue = roundUp(formattedValue + 0.01)
        currentSliderValues[1] = newMaxValue
        const currentMaxField = filterWrapper.querySelector('[data-price-max]')
        if (currentMaxField) {
          currentMaxField.value = newMaxValue.toFixed(2)
        }
      }

      currentSliderValues[0] = formattedValue
      rangeSliderInstance.value([formattedValue, currentSliderValues[1]])
      handlePriceRangeChange(formattedValue, currentSliderValues[1])
    }
  })

  maxPriceField.addEventListener('input', function (e) {
    const inputValue = e.target.value.trim()

    if (inputValue === '') {
      return
    }

    const targetValue = parseFloat(inputValue)

    if (!isNaN(targetValue) && targetValue >= 0) {
      const formattedValue = roundUp(targetValue)

      if (formattedValue < currentSliderValues[0]) {
        const newMinValue = formatPrice(Math.max(0, formattedValue - 0.01))
        currentSliderValues[0] = newMinValue
        const currentMinField = filterWrapper.querySelector('[data-price-min]')
        if (currentMinField) {
          currentMinField.value = newMinValue.toFixed(2)
        }
      }

      currentSliderValues[1] = formattedValue
      rangeSliderInstance.value([currentSliderValues[0], formattedValue])
      handlePriceRangeChange(currentSliderValues[0], formattedValue)
    }
  })

  minPriceField.addEventListener('blur', function (e) {
    const value = parseFloat(e.target.value)
    if (!isNaN(value)) {
      e.target.value = formatPrice(value).toFixed(2)
    }
  })

  maxPriceField.addEventListener('blur', function (e) {
    const value = parseFloat(e.target.value)
    if (!isNaN(value)) {
      e.target.value = formatPrice(value).toFixed(2)
    }
  })
}

function updatePriceRange() {
  currentPriceRange = null

  destroySlider()

  initializeSlider()

  const activeFilters = getActiveFilters()
  const filteredTariffs = filterTariffs(allTariffs, activeFilters.filters)
  applyFilters(filteredTariffs)
}

export function updatePeriodFilter(period) {
  currentPeriod = period
  updatePriceRange()
}

export function updateIpTypeFilter(ipType) {
  currentIpType = ipType
  updatePriceRange()
}

currencyStore.subscribe(() => {
  currencyData = currencyStore.getSelectedCurr()

  updateCurrencySymbols()
  updatePriceRange()
})

function updateFilterBlockVisibility() {
  const activeFilters = getActiveFilters()
  const hasActiveFilters = activeFilters.filters.size > 0

  if (hasActiveFilters && filterActionBar) {
    filterActionBar.classList.add('show')
  } else {
    filterActionBar?.classList?.remove('show')
  }
}

const getCategoryCheckboxes = () => {
  if (!cachedcategoryCheckboxes) {
    cachedcategoryCheckboxes = [...document.querySelectorAll('.filter__option[data-type]')]
  }
  return cachedcategoryCheckboxes
}

const getTariffElements = () => {
  if (!cachedTariffElements) {
    const isDesktop = window.innerWidth >= 1100
    cachedTariffElements = new Map()

    if (isDesktop) {
      if (tableContainer) {
        const elements = tableContainer.querySelectorAll('[data-cloud-id]')
        elements.forEach(element => {
          const cloudId = element.dataset.cloudId
          const tr = element.closest('tr')
          if (cloudId && tr) {
            cachedTariffElements.set(cloudId, tr)
          }
        })
      }
    } else {
      if (listContainer) {
        const elements = listContainer.querySelectorAll('[data-cloud-id]')
        elements.forEach(element => {
          const cloudId = element.dataset.cloudId
          const li = element.closest('li')
          if (cloudId && li) {
            cachedTariffElements.set(cloudId, li)
          }
        })
      }
    }
  }
  return cachedTariffElements
}

function getActiveFilters() {
  const filters = new Map()
  const filterDetails = new Map()

  document.querySelectorAll('.filter__option[data-type] input:checked').forEach(input => {
    const label = input.closest('.filter__option')
    const type = label?.dataset.type
    const value = label?.dataset.value
    const id = input.id

    if (!type || !value) {
      console.warn('Data-type or data-value attributes are missing:', label)
      return
    }

    if (!filters.has(type)) {
      filters.set(type, new Set())
    }
    filters.get(type).add(value)

    if (!filterDetails.has(type)) {
      filterDetails.set(type, [])
    }
    filterDetails.get(type).push({
      id: id,
      type: type,
      value: value,
    })
  })

  if (currentPriceRange) {
    filters.set('price', currentPriceRange)
  }

  return {
    filters: filters,
    details: filterDetails,
  }
}

function generateFilterList(filterDetails) {
  const allItems = []

  for (const [, items] of filterDetails.entries()) {
    allItems.push(...items)
  }

  if (currentPriceRange) {
    const [minPrice, maxPrice] = currentPriceRange
    allItems.push({
      id: 'price-filter',
      type: t('price_range'),
      value: `${minPrice.toFixed(2)} - ${maxPrice.toFixed(2)} ${currencyData.symbol}`,
      isPriceFilter: true,
    })
  }

  return allItems
    .map(
      item => `
      <li class="filter__cloud main_filter">
        <label class="filter__cloud_value" ${
          item.isPriceFilter ? 'data-price-filter' : `for='${item.id}'`
        }>
          <span class="filter_cloud_param_type">${t(item.type)}:</span> ${item.value}
          <svg xmlns="http://www.w3.org/2000/svg" class="close_icon" viewBox="0 0 24 24" width="24" height="24" fill="none">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 7 7 17M7 7l10 10"></path>
          </svg>
        </label>
      </li>
    `,
    )
    .join('')
}

function getFilteredTariffsByLocation() {
  if (!currentLocationFilter) {
    return allTariffs
  }

  return allTariffs.filter(tariff => {
    return tariff.datacenter === currentLocationFilter
  })
}

function updateFilterDisplay() {
  const activeFilters = getActiveFilters()
  const filterListElement = document.querySelector('[data-filtered-list]')

  if (filterListElement) {
    const filterHTML = generateFilterList(activeFilters.details)
    filterListElement.innerHTML = filterHTML
  }
}

function filterTariffs(tariffs, filters) {
  if (!Array.isArray(tariffs)) {
    console.warn('Tariffs were not found or are in the wrong format')
    return []
  }

  const locationFilteredTariffs = getFilteredTariffsByLocation()

  if (filters.size === 0) {
    return locationFilteredTariffs
  }

  return locationFilteredTariffs.filter(tariff => {
    for (const [key, valuesSet] of filters.entries()) {
      if (key === 'price') {
        const tariffPrice = getTariffPrice(tariff)
        const [minPrice, maxPrice] = valuesSet

        if (isNaN(tariffPrice) || tariffPrice < minPrice || tariffPrice > maxPrice) {
          return false
        }
        continue
      }

      const tariffValue = tariff[key]
      if (tariffValue === undefined || !valuesSet.has(String(tariffValue))) {
        return false
      }
    }
    return true
  })
}

export function updateLocationFilter(datacenter) {
  currentLocationFilter = datacenter

  updatePriceRange()

  const activeFilters = getActiveFilters()
  const filteredTariffs = filterTariffs(allTariffs, activeFilters.filters)
  applyFilters(filteredTariffs)
}

function updateDisabledFilters(emptyActiveFilter) {
  const currentFilters = emptyActiveFilter ? new Map() : getActiveFilters()?.filters
  const allFilterOptions = getCategoryCheckboxes()

  allFilterOptions.forEach(option => {
    const input = option.querySelector('input')

    if (input?.checked) {
      option.classList.remove('disabled')
      return
    }

    const type = option.dataset.type
    const value = option.dataset.value

    if (!type || !value) return

    const tempFilters = new Map()

    for (const [key, values] of currentFilters.entries()) {
      if (key !== type) {
        tempFilters.set(key, new Set(values))
      }
    }

    tempFilters.set(type, new Set([value]))

    const wouldHaveResults = filterTariffs(allTariffs, tempFilters).length > 0

    option.classList.toggle('disabled', !wouldHaveResults)
  })
}

function getGlobalPriceRange() {
  const locationFilteredTariffs = getFilteredTariffsByLocation()

  const prices = locationFilteredTariffs.map(t => getTariffPrice(t)).filter(p => !isNaN(p))

  if (prices.length === 0) {
    console.warn('No valid prices in the tariffs for the current location')
    return {
      min: 0,
      max: 100,
    }
  }

  return {
    min: roundDown(Math.min(...prices)),
    max: roundUp(Math.max(...prices)),
  }
}

function handlePriceRangeChange(minPrice, maxPrice) {
  const { min: globalMin, max: globalMax } = getGlobalPriceRange()

  const formattedMinPrice = formatPrice(minPrice)
  const formattedMaxPrice = roundUp(maxPrice)

  if (formattedMinPrice === globalMin && formattedMaxPrice === globalMax) {
    currentPriceRange = null
  } else {
    currentPriceRange = [formattedMinPrice, formattedMaxPrice]
  }

  const activeFilters = getActiveFilters()
  const filteredTariffs = filterTariffs(allTariffs, activeFilters.filters)

  applyFilters(filteredTariffs)
}

function handleCheckboxChange(e) {
  try {
    const filterWrapper = e.target.closest('.filter__btn_wrapper')
    const checkedCount = filterWrapper?.querySelectorAll('input:checked')?.length || 0
    const filterAmountEl = filterWrapper?.querySelector('[data-filter-amount]')

    if (filterAmountEl) {
      filterAmountEl.classList.toggle('show', checkedCount > 0)
      filterAmountEl.textContent = checkedCount.toString()
    }

    const activeFilters = getActiveFilters()
    const filteredTariffs = filterTariffs(allTariffs, activeFilters.filters)

    applyFilters(filteredTariffs)
  } catch (error) {
    console.error('Error processing a filter change:', error)
  }
}

function createNoResultsBlock() {
  const noResultsBlock = document.createElement('div')
  noResultsBlock.className = 'no-results-block'
  noResultsBlock.setAttribute('data-no-results', '')

  noResultsBlock.innerHTML = `
    <div class="no-results-content">
      <h2>${t('no_comparison_tariffs_found')}</h2>
      <p>${t('try_changing_filters')}</p>
      <button type="button" class="comparison_filter_btn open comparison_filter_btn_clear" data-clear-all-filters>
        ${t('clear_all_comparison_filters')}
      </button>
    </div>
  `

  return noResultsBlock
}

function toggleNoResultsBlock(show) {
  const isDesktop = window.innerWidth >= 1100
  const container = isDesktop ? tableContainer : listContainer

  if (!container) return

  let noResultsBlock = document.querySelector('[data-no-results]')

  if (show) {
    if (!noResultsBlock) {
      noResultsBlock = createNoResultsBlock()
      container.parentNode.insertBefore(noResultsBlock, container.nextSibling)

      const clearAllBtn = noResultsBlock.querySelector('[data-clear-all-filters]')
      clearAllBtn?.addEventListener('click', clearFilters)
    }
    noResultsBlock.style.display = 'block'

    if (isDesktop && tableContainer) {
      const tableContent = tableContainer.querySelector('table')
      if (tableContent) tableContent.style.display = 'none'
    } else if (listContainer) {
      const listContent = listContainer.querySelector('ul')
      if (listContent) listContent.style.display = 'none'
    }
  } else {
    if (noResultsBlock) {
      noResultsBlock.style.display = 'none'
    }

    if (isDesktop && tableContainer) {
      const tableContent = tableContainer.querySelector('table')
      if (tableContent) tableContent.style.display = ''
    } else if (listContainer) {
      const listContent = listContainer.querySelector('ul')
      if (listContent) listContent.style.display = ''
    }
  }
}

function applyFilters(filteredTariffs) {
  const hasResults = filteredTariffs.length > 0

  updateTariffsElementsVisibility(filteredTariffs)
  updateDisabledFilters()
  updateFilterBlockVisibility()
  updateFilterDisplay()
  updateFoundItems(filteredTariffs)

  toggleNoResultsBlock(!hasResults)
}

function updateFoundItems(filteredTariffs) {
  if (foundItems) {
    foundItems.innerHTML = `${t('found')} ${filteredTariffs.length} ${t('pcs')}`
  }
}

function updateTariffsElementsVisibility(filteredTariffs) {
  const filteredTariffsIds = filteredTariffs.map(item => String(item.id))
  const tariffElements = getTariffElements()
  const visibleIdsSet = new Set(filteredTariffsIds)

  tariffElements.forEach((trElement, cloudId) => {
    if (visibleIdsSet.has(cloudId)) {
      trElement.classList.remove('hidden')
    } else {
      trElement.classList.add('hidden')
    }
  })
}

function clearFilters() {
  document.querySelectorAll('.filter__option[data-type] input:checked').forEach(input => {
    input.checked = false
  })

  document.querySelectorAll('[data-filter-amount]').forEach(counter => {
    counter.classList.remove('show')
    counter.textContent = '0'
  })

  currentPriceRange = null

  if (rangeSliderInstance) {
    const { min, max } = getGlobalPriceRange()
    currentSliderValues = [min, max]
    rangeSliderInstance.value([min, max])

    const minPriceField = filterWrapper.querySelector('[data-price-min]')
    const maxPriceField = filterWrapper.querySelector('[data-price-max]')

    if (minPriceField && maxPriceField) {
      minPriceField.value = min.toFixed(2)
      maxPriceField.value = max.toFixed(2)
    }
  }

  const locationFilteredTariffs = getFilteredTariffsByLocation()
  applyFilters(locationFilteredTariffs)
  updateDisabledFilters(true)
  updateFilterBlockVisibility()
  updateFilterDisplay()
}

function clearPriceFilter() {
  currentPriceRange = null

  if (rangeSliderInstance) {
    const { min, max } = getGlobalPriceRange()
    currentSliderValues = [min, max]
    rangeSliderInstance.value([min, max])

    const minPriceField = filterWrapper.querySelector('[data-price-min]')
    const maxPriceField = filterWrapper.querySelector('[data-price-max]')

    if (minPriceField && maxPriceField) {
      minPriceField.value = min.toFixed(2)
      maxPriceField.value = max.toFixed(2)
    }
  }

  const activeFilters = getActiveFilters()
  const filteredTariffs = filterTariffs(allTariffs, activeFilters.filters)
  applyFilters(filteredTariffs)
}

if (filterWrapper) {
  document.addEventListener('change', e => {
    if (e.target.type === 'checkbox' && e.target.closest('.filter__option[data-type]')) {
      handleCheckboxChange(e)
    }
  })

  document.addEventListener('click', e => {
    const filterBtn = e.target.closest('.filter__btn')
    const currentWrapper = e.target.closest('.filter__btn_wrapper')

    document.querySelectorAll('.filter__btn_wrapper').forEach(wrapper => {
      if (wrapper !== currentWrapper) {
        const btn = wrapper.querySelector('.filter__btn')
        const next = btn?.nextElementSibling

        btn?.classList.remove('opened')
        next?.classList.remove('opened')
      }
    })

    if (filterBtn && currentWrapper) {
      filterBtn.classList.toggle('opened')
      const nextElement = filterBtn.nextElementSibling
      if (nextElement) {
        nextElement.classList.toggle('opened')
      }
    }

    const openFilterBtn = e.target.closest('[data-comparison-filter-toggle]')
    if (openFilterBtn) {
      filterWrapper.classList.toggle('show')
      openFilterBtn.classList.toggle('open')
    }

    const closeIcon = e.target.closest('.close_icon')
    if (closeIcon) {
      const label = closeIcon.closest('.filter__cloud_value')

      if (label?.hasAttribute('data-price-filter')) {
        clearPriceFilter()
      } else {
        const filterId = label?.getAttribute('for')
        if (filterId) {
          const checkbox = document.getElementById(filterId)
          if (checkbox) {
            checkbox.checked = false
            checkbox.dispatchEvent(new Event('change', { bubbles: true }))
          }
        }
      }
    }
  })

  clearFilterEl?.addEventListener('click', clearFilters)

  i18next.on('loaded', function () {
    updateDisabledFilters()
    updateCurrencySymbols()

    if (allTariffs.length > 0) {
      initializeSlider()
      const activeFilters = getActiveFilters()
      const filteredTariffs = filterTariffs(allTariffs, activeFilters.filters)

      applyFilters(filteredTariffs)
    } else {
      toggleNoResultsBlock(true)
      updateFoundItems([])
    }

    updateFilterBlockVisibility()
  })

  window.addEventListener('resize', () => {
    cachedTariffElements = null

    const activeFilters = getActiveFilters()

    const filteredTariffs = filterTariffs(allTariffs, activeFilters.filters)

    applyFilters(filteredTariffs)
  })
}
